var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadedfiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4140f2;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M796.3,897.5h-458.13c-75.91,0-137.67-61.76-137.67-137.67v-438.65c0-75.91,61.76-137.67,137.67-137.67l103.71-.34c38.89-.15,75.31,17.07,99.93,47.18l67.47,82.53c3.74,4.58,9.28,7.23,15.2,7.27l168.68,1.14c35.28.24,68.39,14.16,93.24,39.21,24.85,25.05,38.51,58.27,38.47,93.55l-.37,315.3c0,70.66-57.51,128.17-128.2,128.17ZM442.31,232.16c-.09,0-.18,0-.26,0l-103.79.34c-48.98,0-88.75,39.78-88.75,88.67v438.65c0,48.89,39.78,88.67,88.67,88.67h458.13c43.67,0,79.2-35.53,79.2-79.2l.37-315.33c.05-45.84-37.2-83.39-83.04-83.7l-168.68-1.14c-20.55-.14-39.8-9.34-52.8-25.25l-67.47-82.53c-15.18-18.56-37.6-29.19-61.57-29.19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M858.98,348.5h-49v-48.93c0-37.17-30.24-67.41-67.41-67.41h-333.07v-49h333.07c64.19,0,116.41,52.22,116.41,116.41v48.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedfiles);
export default __webpack_public_path__ + "static/media/uploadedfiles.a482bf377801387ff964437f91a17fd2.svg";
export { ForwardRef as ReactComponent };